import { Component, OnInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';
import { HCPStatisticService } from '../../services/hcpstatistic.service';
import { BasicError } from '../../models/error/error';

import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';

import { Study } from '../../models/study';
import { User } from '../../models/user';
import { Questionnaire } from '../../models/questionnaire';
import { Answersheet } from '../../models/answersheet';
import { HCPGroupService } from '../../services/hcpgroup.service';
import { GroupService } from '../../services/group.service';
import { HcpQuestionnaireService } from '../../services/hcp-questionnaire.service';
import { TranslateService } from '../../services/translate.service';
import {
  QuestionnaireElement, QuestionnaireElementHeadline, QuestionnaireElementYesNo,
  QuestionnaireElementSlider, QuestionnaireElementSingleChoice, QuestionnaireElementTextDate,
  QuestionnaireElementMultipleChoice, QuestionnaireElementTextString,
  QuestionnaireElementTextArea
} from '../../models/questionnaire-element';
declare var Chart: any;
declare var $: any;

@Component({
  selector: 'app-group-details-statistics',
  templateUrl: './group-details-statistics.component.html',
  styleUrls: ['./group-details-statistics.component.css']
})
export class GroupDetailsStatisticsComponent implements OnInit {
  public masterStudyId = 1;
  public masterStudy: Study = null;
  public currentStudy: Study = null;
  public studyId: any;
  public isEmptyStat = false;

  public questionnaires = [];
  public questionnairesIsLoaded = false;
  public questionnairesAmount = 0;
  public questionnairesOnce = 0;
  public questionnairesMultiple = 0;
  public questionnairesMultipleElementCount = 0; // Counter for loading the elements
  public multipleQuestionaires = [];
  public multipleQuestionnairesElements = {};
  public questionnaireAnswersheets = {};
  public answerSheetsLoaded = false;
  public members = [];
  public amountAnswersheets = 0;
  public answersheets = {};
  public allAnswersheets = [];
  public loadWeekdayCanvas = false;
  public barChart;
  public loadHoursCanvas = false;
  public lineChart;
  public questCharts = {};
  public chartDrawCounter = {};
  public legends = {};


  public selectTime = 'all';
  public fromTime = null;
  public toTime = null;

  public getAnswersFrom = null;
  public getAnswersTo = null;
  public compareUser: User = null;
  public compareUserNr = '-1';
  public compareUserAnswersheets = {};
  public compareUserAllAnswersheets = [];


  constructor(private naviService: NaviService, private statistics: HCPStatisticService,
    private route: ActivatedRoute, private location: Location, private hcpGroup: HCPGroupService, private groupService: GroupService,
    private hcpQuest: HcpQuestionnaireService, private translate: TranslateService) { }

  ngOnInit() {
    this.questionnairesMultipleElementCount = 0;
    this.questionnairesIsLoaded = false;
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.studyId = params.get('id');
      this.getStudy(this.studyId);
      // return this.hcpQuest.getQuestionnairesOfStudy(params.get('id'))
      return this.hcpQuest.getQuestionnairesOfStudy(this.masterStudyId + '')
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while getting Questionnaires of a study');
        console.log(dd);
      } else if (dd instanceof Array) {
        if (dd.length > 0) {
          this.isEmptyStat = false;
          this.questionnairesAmount = dd.length;
          this.questionnaires = dd;
          this.processQuestionaires();
        }
      }
    });

    this.isEmptyStat = true;
  }

  public changeTime() {
    if (this.selectTime === 'all') {
      // Getting all Data
      this.getAnswersFrom = null;
      this.getAnswersTo = null;
      this.processQuestionaires();
    } else if (this.selectTime !== 'define') {
      // Reload data for the selected time
      const date = new Date();
      date.setDate(date.getDate() + 1);
      const to = Math.floor(date.getTime() / 1000);
      let toString = date.getFullYear() + '-';
      toString = ((date.getMonth() + 1) > 9) ? toString + (date.getMonth() + 1) : toString + '0' + (date.getMonth() + 1);
      toString = toString + '-';
      toString = (date.getDate() > 9) ? toString + date.getDate() : toString + '0' + date.getDate();
      date.setDate(date.getDate() - 1);
      let from = null;
      (this.selectTime === '7days') ? date.setDate(date.getDate() - 7) : date.setDate(date.getDate() - 30);
      from = Math.floor(date.getTime() / 1000);
      let fromString = date.getFullYear() + '-';
      fromString = ((date.getMonth() + 1) > 9) ? fromString + (date.getMonth() + 1) : fromString + '0' + (date.getMonth() + 1);
      fromString = fromString + '-';
      fromString = (date.getDate() > 9) ? fromString + date.getDate() : fromString + '0' + date.getDate();

      this.getAnswersFrom = fromString;
      this.getAnswersTo = toString;
      this.processQuestionaires();
    } else {
      // Do nothing until time was selected
    }
  }

  public changePeriod() {
    let from = null;
    let to = null;
    const todate = new Date();
    if (this.fromTime !== '' && this.fromTime !== null) {
      const sFrom = this.fromTime.split('-');
      todate.setFullYear(((+sFrom[0]) + 0)); // Set Year
      todate.setMonth(((+sFrom[1]) - 1)); // Set Month
      todate.setDate(((+sFrom[2]) + 0)); // Set Date

      from = this.fromTime;
    } else {
      from = null;
    }

    const fromdate = new Date();
    if (this.toTime !== '' && this.toTime !== null) {
      const sFrom = this.toTime.split('-');
      fromdate.setFullYear(((+sFrom[0]) + 0)); // Set Year
      fromdate.setMonth(((+sFrom[1]) - 1)); // Set Month
      fromdate.setDate(((+sFrom[2]) + 0)); // Set Date

      to = this.toTime;
    } else {
      to = null;
    }

    // Do some Magic stuff
    this.getAnswersFrom = from;
    this.getAnswersTo = to;
    this.processQuestionaires();
  }

  /**
   * This function is triggered if an Member is choosen and gets all his answersheets
   */
  public changeMember() {
    this.compareUserAnswersheets = {};
    this.compareUserAllAnswersheets = [];
    if (this.compareUserNr === '-1') {
      this.compareUser = null;
    } else {
      this.compareUser = this.members[this.compareUserNr];
      for (let j = 0; j < this.multipleQuestionaires.length; j++) {
        const qId = this.multipleQuestionaires[j].getId();
        const aSheetsUser = []; // Answersheets of user for this questionnaire
        for (const a of this.answersheets[qId]) {
          if (a instanceof Answersheet && a.getUserId().toString() === this.compareUser.getID().toString()) {
            aSheetsUser.push(a);
            this.compareUserAllAnswersheets.push(a);
          }
        }
        this.compareUserAnswersheets[qId] = aSheetsUser;
      }
    }

    this.changeMemberCalcWeekDay();
    this.changeMemberCalcHours();

    // Going through each multiple questionnaire
    for (const quest of this.multipleQuestionaires) {
      if (quest instanceof Questionnaire && this.multipleQuestionnairesElements[quest.getId().toString()] !== undefined) {
        // Going through each questionnaire element
        for (let i = 0; i < this.multipleQuestionnairesElements[quest.getId().toString()]['elements'].length; i++) {
          const element = this.multipleQuestionnairesElements[quest.getId().toString()]['elements'][i];

          if (element.constructor.name === 'QuestionnaireElementYesNo') {
            // Found pie chart, generate data for it and display data
            this.changeMemberYesNoPie(quest, element, i);
          }

          if (element.constructor.name === 'QuestionnaireElementSingleChoice') {
            // Found singlechoice element, generate data for compareUser
            this.changeMemberSingleChoice(quest, element, i);
          }

          if (element.constructor.name === 'QuestionnaireElementMultipleChoice') {
            // Found multiplechoice element, generate data for compareUser
            this.changeMemberMultipleChoice(quest, element, i);
          }

          if (element.constructor.name === 'QuestionnaireElementSlider') {
            this.changeMemberSlider(quest, element, i);
          }
        }
      }
    }
  }

  /**
   * Setting the compareuser weeklyday statistics
   */
  public changeMemberCalcWeekDay() {
    if (this.barChart === undefined || this.barChart === null) {
      return;
    }

    if (this.compareUserNr === '-1') {
      const dSet = this.barChart.data.datasets[0];
      this.barChart.data.datasets = [dSet];
      this.barChart.update();
    } else {
      const stats = this.statistics.calcAverageWeekdays(this.compareUserAllAnswersheets);
      const nSet = {
        data: stats,
        backgroundColor: [
          'rgba(70, 70, 70, 0.7)',
          'rgba(70, 70, 70, 0.7)',
          'rgba(70, 70, 70, 0.7)',
          'rgba(70, 70, 70, 0.7)',
          'rgba(70, 70, 70, 0.7)',
          'rgba(70, 70, 70, 0.7)'
        ],
        borderColor: [
          'rgba(70, 70, 70, 1)',
          'rgba(70, 70, 70, 1)',
          'rgba(70, 70, 70, 1)',
          'rgba(70, 70, 70, 1)',
          'rgba(70, 70, 70, 1)',
          'rgba(70, 70, 70, 1)'
        ],
      }

      if (this.barChart.data.datasets.length > 1) {
        this.barChart.data.datasets[1] = nSet;
      } else {
        this.barChart.data.datasets.push(nSet);
      }
      this.barChart.update();
    }
  }

  /**
   * Setting data of compareUser to calculated hours
   */
  public changeMemberCalcHours() {
    if (this.lineChart === undefined || this.lineChart === null) {
      return;
    }

    if (this.compareUserNr === '-1') {
      const dSet = this.lineChart.data.datasets[0];
      this.lineChart.data.datasets = [dSet];
      this.lineChart.update();
    } else {
      const stats = this.statistics.calcAverageHours(this.compareUserAllAnswersheets);
      const nSet = {
        data: stats,
        backgroundColor:
          'rgba(70, 70, 70, 0.7)',
        borderColor:
          'rgba(70, 70, 70, 1)',
      }

      if (this.lineChart.data.datasets.length > 1) {
        this.lineChart.data.datasets[1] = nSet;
      } else {
        this.lineChart.data.datasets.push(nSet);
      }
      this.lineChart.update();
    }
  }

  /**
   * This function sets the compare user data of this dataset
   * @param quest Questionnaire
   * @param element questionnaireElementYesNo
   * @param i index
   */
  public changeMemberYesNoPie(quest: Questionnaire, element: QuestionnaireElementYesNo, i: number) {
    if (this.questCharts[quest.getId().toString()] === undefined || this.questCharts[quest.getId().toString()] === null ||
      this.questCharts[quest.getId().toString()][i] === undefined || this.questCharts[quest.getId().toString()][i] === null) {
      // Element doesn't exist so return
      return;
    }

    if (this.compareUserNr === '-1') {
      // Return YesNoChart to normal
      const origStatCount = [this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data[0],
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data[1]];
      const origStatColor = [this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor[0],
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor[1]];
      const origLabels = [this.questCharts[quest.getId().toString()][i][0].data.labels[0],
      this.questCharts[quest.getId().toString()][i][0].data.labels[1]];
      this.questCharts[quest.getId().toString()][i][0].data.labels = origLabels;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = origStatCount;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor = origStatColor;
      this.questCharts[quest.getId().toString()][i][0].update();

      const origStatWeek = [this.questCharts[quest.getId().toString()][i][1].data.datasets[0],
      this.questCharts[quest.getId().toString()][i][1].data.datasets[1]];
      this.questCharts[quest.getId().toString()][i][1].data.datasets = origStatWeek;
      this.questCharts[quest.getId().toString()][i][1].update();

      const origStatHour = [this.questCharts[quest.getId().toString()][i][3].data.datasets[0],
      this.questCharts[quest.getId().toString()][i][3].data.datasets[1]];
      this.questCharts[quest.getId().toString()][i][3].data.datasets = origStatHour;
      this.questCharts[quest.getId().toString()][i][3].update();
    } else {
      // Add Data of User to it
      const stats = this.statistics.calcYesNoAnswers(element, this.compareUserAnswersheets[quest.getId().toString()]);

      const nLabel = this.questCharts[quest.getId().toString()][i][0].data.labels;
      if (nLabel.length > 2) {
        nLabel[2] = this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Ja';
        nLabel[3] = this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Nein';
      } else {
        nLabel.push(this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Ja');
        nLabel.push(this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Nein');
      }

      const backgroundColor = [
        'rgba(75, 192, 192, 1)',
        'rgba(255,99,132,1)',
        'rgba(70,70,70,1)',
        'rgba(180,180,180,1)'
      ];

      const figures = this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data;
      if (figures.length > 2) {
        figures[2] = stats.count[0];
        figures[3] = stats.count[1];
      } else {
        figures.push(stats.count[0]);
        figures.push(stats.count[1]);
      }

      this.questCharts[quest.getId().toString()][i][0].data.labels = nLabel;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = figures;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor = backgroundColor;
      this.questCharts[quest.getId().toString()][i][0].update();

      const setsWeek = this.questCharts[quest.getId().toString()][i][1].data.datasets;
      const setsWeekYes = {
        label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Ja',
        data: stats.weekdayYes,
        backgroundColor: 'rgba(70, 70, 70, 0.8)',
        borderColor: 'rgba(70, 70, 70, 1)'
      };

      const setsWeekNo = {
        label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Nein',
        data: stats.weekdayNo,
        backgroundColor: 'rgba(180, 180, 180, 0.8)',
        borderColor: 'rgba(180, 180, 180, 1)'
      }

      if (setsWeek.length > 2) {
        setsWeek[2] = setsWeekYes;
        setsWeek[3] = setsWeekNo;
      } else {
        setsWeek.push(setsWeekYes);
        setsWeek.push(setsWeekNo);
      }

      this.questCharts[quest.getId().toString()][i][1].data.datasets = setsWeek;
      this.questCharts[quest.getId().toString()][i][1].update();

      const setsHour = this.questCharts[quest.getId().toString()][i][3].data.datasets;
      const setsHourYes = {
        label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Ja',
        data: stats.hoursYes,
        backgroundColor: 'rgba(70, 70, 70, 0.4)',
        borderColor: 'rgba(70, 70, 70, 1)'
      };

      const setsHourNo = {
        label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - Nein',
        data: stats.hoursNo,
        backgroundColor: 'rgba(180, 180, 180, 0.4)',
        borderColor: 'rgba(180, 180, 180, 1)'
      }

      if (setsHour.length > 2) {
        setsHour[3] = setsHourYes;
        setsHour[2] = setsHourNo;
      } else {
        // setsHour.push(setsHourYes);
        setsHour.push(setsHourNo);
        setsHour.push(setsHourYes);
      }

      this.questCharts[quest.getId().toString()][i][3].data.datasets = setsHour;
      this.questCharts[quest.getId().toString()][i][3].update();
    }
  }

  /**
   * This function sets the compare data of this dataset
   * @param quest questionnaire of study
   * @param element element of questionnaire (QuestionnaireElementSingleChoice)
   * @param i index
   */
  public changeMemberSingleChoice(quest: Questionnaire, element: QuestionnaireElementSingleChoice, i: number) {
    if (this.questCharts[quest.getId().toString()] === undefined || this.questCharts[quest.getId().toString()] === null ||
      this.questCharts[quest.getId().toString()][i] === undefined || this.questCharts[quest.getId().toString()][i] === null) {
      // Element doesn't exist so return
      return;
    }

    if (this.compareUserNr === '-1') {
      // Return YesNoChart to normal
      const origLegends = [];
      const origCount = [];
      const origCountBg = [];
      const origWeekSet = [];
      const origHourSet = [];
      const origLabels = [];

      for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        if (this.legends[quest.getId().toString()][i] !== undefined) {
          const l = this.legends[quest.getId().toString()][i][j];
          origLegends.push(l);
        }

        origCount.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data[j]);
        origCountBg.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor[j]);

        // Get labels
        origLabels.push(this.questCharts[quest.getId().toString()][i][0].data.labels[j]);

        // Get week and hour data
        origWeekSet.push(this.questCharts[quest.getId().toString()][i][1].data.datasets[j]);
        origHourSet.push(this.questCharts[quest.getId().toString()][i][2].data.datasets[j]);
      }

      if (this.legends[quest.getId().toString()][i] !== undefined) {
        this.legends[quest.getId().toString()][i] = origLegends;
      }

      this.questCharts[quest.getId().toString()][i][0].data.labels = origLabels;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = origCount;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor = origCountBg;
      this.questCharts[quest.getId().toString()][i][1].data.datasets = origWeekSet;
      this.questCharts[quest.getId().toString()][i][2].data.datasets = origHourSet;
      this.questCharts[quest.getId().toString()][i][1].update();
      this.questCharts[quest.getId().toString()][i][2].update();
      this.questCharts[quest.getId().toString()][i][0].update();

    } else {
      // Add Data of User to it
      const aLength = element.getAnswers(this.translate.getSingleElementLanguage()).length;
      const stats = this.statistics.calcSingleChoiceAnswers(element, this.compareUserAnswersheets[quest.getId().toString()])

      const compareBackground = ['rgba(180, 180, 180, 0.7)',
        'rgba(70, 70, 70, 0.7)',
        'rgba(102, 102, 153, 0.7)',
        'rgba(204, 102, 153, 0.7)',
        'rgba(153, 153, 102, 0.7)',
        'rgba(102, 153, 153, 0.7)',
        'rgba(153, 51, 0, 0.2)'
      ];
      const compareBorders = ['rgba(180, 180, 180, 1)',
        'rgba(70, 70, 70, 1)',
        'rgba(102, 102, 153, 1)',
        'rgba(204, 102, 153, 1)',
        'rgba(153, 153, 102, 1)',
        'rgba(102, 153, 153, 1)',
        'rgba(153, 51, 0, 1)'];

      const nLabel = this.questCharts[quest.getId().toString()][i][0].data.labels;
      const nLabelLength = nLabel.length;

      let countData = [];
      let countDataBg = [];
      const countDataBgAdd = [];

      const setsWeekData = [];
      const setsHourData = [];
      const origSetHour = [];
      const origSetWeek = [];

      let legendTemp = [];
      let legendLength = 0;

      if (this.legends[quest.getId().toString()][i] !== undefined) {
        legendTemp = this.legends[quest.getId().toString()][i];
        legendLength = legendTemp.length;
      }


      for (let k = 0; k < element.getAnswers(this.translate.getSingleElementLanguage()).length; k++) {
        const a = element.getAnswers(this.translate.getSingleElementLanguage())[k];

        // Legends
        if (this.legends[quest.getId().toString()][i] !== undefined) {
          if (legendLength > aLength) {
            legendTemp[(aLength + k)].value = a.toString() + ' - ' + this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName();
          } else {
            legendTemp.push({
              'color': compareBackground[(k % 7)],
              'value': a.toString() + ' - ' + this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName()
            });
          }
        }

        // labels & countData
        if (nLabelLength > aLength) {
          nLabel[(aLength + k)] = this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString();
        } else {
          nLabel.push(this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString());
        }

        // CountData
        countData.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data[k]);
        countDataBg.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor[k]);
        countDataBgAdd.push(compareBackground[(k % 7)]);

        // origsets
        origSetWeek.push(this.questCharts[quest.getId().toString()][i][1].data.datasets[k]);
        origSetHour.push(this.questCharts[quest.getId().toString()][i][2].data.datasets[k]);

        // Generate new sets
        setsWeekData.push({
          label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString(),
          data: stats.weekday[k],
          backgroundColor: compareBackground[(k % 7)],
          borderColor: compareBorders[(k % 7)]
        });

        setsHourData.push({
          label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString(),
          data: stats.hours[k],
          backgroundColor: compareBackground[(k % 7)],
          borderColor: compareBorders[(k % 7)]
        });
      }

      countData = countData.concat(stats.count);
      countDataBg = countDataBg.concat(countDataBgAdd);

      if (this.legends[quest.getId().toString()][i] !== undefined) {
        this.legends[quest.getId().toString()][i] = legendTemp;
      }

      this.questCharts[quest.getId().toString()][i][0].data.labels = nLabel;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = countData;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor = countDataBg;
      this.questCharts[quest.getId().toString()][i][0].update();

      this.questCharts[quest.getId().toString()][i][1].data.datasets = origSetWeek.concat(setsWeekData);
      this.questCharts[quest.getId().toString()][i][1].update();

      this.questCharts[quest.getId().toString()][i][2].data.datasets = origSetHour.concat(setsHourData);
      this.questCharts[quest.getId().toString()][i][2].update();
    }
  }

  /**
   * This function sets the compare data of the slider datasets
   * @param quest questionnaire of study
   * @param element element of questionnaire (QuestionnaireElementSlider)
   * @param i index
   */
  public changeMemberSlider(quest: Questionnaire, element: QuestionnaireElementSlider, i: number) {
    if (this.questCharts[quest.getId().toString()] === undefined || this.questCharts[quest.getId().toString()] === null ||
      this.questCharts[quest.getId().toString()][i] === undefined || this.questCharts[quest.getId().toString()][i] === null) {
      // Element doesn't exist so return
      return;
    }

    if (this.compareUserNr === '-1') {
      const origRanges = [this.questCharts[quest.getId().toString()][i][0].data.datasets[0]];
      const origHours = [this.questCharts[quest.getId().toString()][i][1].data.datasets[0]];

      this.questCharts[quest.getId().toString()][i][0].data.datasets = origRanges;
      this.questCharts[quest.getId().toString()][i][0].update();
      this.questCharts[quest.getId().toString()][i][1].data.datasets = origHours;
      this.questCharts[quest.getId().toString()][i][1].update();
    } else {
      const stats = this.statistics.calcSliderAnswers(element, this.compareUserAnswersheets[quest.getId().toString()]);

      const setRange = this.questCharts[quest.getId().toString()][i][0].data.datasets;
      const setRangeComp = {
        label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName(),
        data: stats.ranges,
        backgroundColor: 'rgba(70, 70, 70, 0.8)',
        borderColor: 'rgba(70, 70, 70, 1)'
      }

      if (setRange.length > 1) {
        setRange[1] = setRangeComp;
      } else {
        setRange.push(setRangeComp);
      }
      this.questCharts[quest.getId().toString()][i][0].data.datasets = setRange;
      this.questCharts[quest.getId().toString()][i][0].update();

      const setWeek = this.questCharts[quest.getId().toString()][i][1].data.datasets;
      const setWeekComp = {
        label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName(),
        data: stats.hours,
        backgroundColor: 'rgba(70, 70, 70, 0.8)',
        borderColor: 'rgba(70, 70, 70, 1)'
      }

      if (setWeek.length > 1) {
        setWeek[1] = setWeekComp;
      } else {
        setWeek.push(setWeekComp);
      }

      this.questCharts[quest.getId().toString()][i][1].data.datasets = setWeek;
      this.questCharts[quest.getId().toString()][i][1].update();
    }
  }

  /**
   * Showing compare user data for multiple choice questions
   * @param quest Questionnaire to get Data from
   * @param element questionnaire element multiple choice
   * @param i index
   */
  public changeMemberMultipleChoice(quest: Questionnaire, element: QuestionnaireElementMultipleChoice, i: number) {
    if (this.questCharts[quest.getId().toString()] === undefined || this.questCharts[quest.getId().toString()] === null ||
      this.questCharts[quest.getId().toString()][i] === undefined || this.questCharts[quest.getId().toString()][i] === null) {
      // Element doesn't exist so return
      return;
    }

    if (this.compareUserNr === '-1') {
      // Return YesNoChart to normal
      const origLegends = [];
      const origCount = [];
      const origCountBg = [];
      const origWeekSet = [];
      const origHourSet = [];
      const origLabels = [];

      for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        if (this.legends[quest.getId().toString()][i] !== undefined) {
          const l = this.legends[quest.getId().toString()][i][j];
          origLegends.push(l);
        }

        origCount.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data[j]);
        origCountBg.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor[j]);

        // Get labels
        origLabels.push(this.questCharts[quest.getId().toString()][i][0].data.labels[j]);

        // Get week and hour data
        origWeekSet.push(this.questCharts[quest.getId().toString()][i][1].data.datasets[j]);
        origHourSet.push(this.questCharts[quest.getId().toString()][i][2].data.datasets[j]);
      }

      if (this.legends[quest.getId().toString()][i] !== undefined) {
        this.legends[quest.getId().toString()][i] = origLegends;
      }

      this.questCharts[quest.getId().toString()][i][0].data.labels = origLabels;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = origCount;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor = origCountBg;
      this.questCharts[quest.getId().toString()][i][1].data.datasets = origWeekSet;
      this.questCharts[quest.getId().toString()][i][2].data.datasets = origHourSet;
      this.questCharts[quest.getId().toString()][i][1].update();
      this.questCharts[quest.getId().toString()][i][2].update();
      this.questCharts[quest.getId().toString()][i][0].update();

    } else {
      // Add Data of User to it
      const aLength = element.getAnswers(this.translate.getSingleElementLanguage()).length;
      const stats = this.statistics.calcMultipleAnswers(element, this.compareUserAnswersheets[quest.getId().toString()])

      const compareBackground = ['rgba(180, 180, 180, 0.7)',
        'rgba(70, 70, 70, 0.7)',
        'rgba(102, 102, 153, 0.7)',
        'rgba(204, 102, 153, 0.7)',
        'rgba(153, 153, 102, 0.7)',
        'rgba(102, 153, 153, 0.7)',
        'rgba(153, 51, 0, 0.2)'
      ];
      const compareBorders = ['rgba(180, 180, 180, 1)',
        'rgba(70, 70, 70, 1)',
        'rgba(102, 102, 153, 1)',
        'rgba(204, 102, 153, 1)',
        'rgba(153, 153, 102, 1)',
        'rgba(102, 153, 153, 1)',
        'rgba(153, 51, 0, 1)'];

      const nLabel = this.questCharts[quest.getId().toString()][i][0].data.labels;
      const nLabelLength = nLabel.length;

      let countData = [];
      let countDataBg = [];
      const countDataBgAdd = [];

      const setsWeekData = [];
      const setsHourData = [];
      const origSetHour = [];
      const origSetWeek = [];

      let legendTemp = [];
      let legendLength = 0;

      if (this.legends[quest.getId().toString()][i] !== undefined) {
        legendTemp = this.legends[quest.getId().toString()][i];
        legendLength = legendTemp.length;
      }


      for (let k = 0; k < element.getAnswers(this.translate.getSingleElementLanguage()).length; k++) {
        const a = element.getAnswers(this.translate.getSingleElementLanguage())[k];

        // Legends
        if (this.legends[quest.getId().toString()][i] !== undefined) {
          if (legendLength > aLength) {
            legendTemp[(aLength + k)].value = a.toString() + ' - ' + this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName();
          } else {
            legendTemp.push({
              'color': compareBackground[(k % 7)],
              'value': a.toString() + ' - ' + this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName()
            });
          }
        }

        // labels & countData
        if (nLabelLength > aLength) {
          nLabel[(aLength + k)] = this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString();
        } else {
          nLabel.push(this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString());
        }

        // CountData
        countData.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data[k]);
        countDataBg.push(this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor[k]);
        countDataBgAdd.push(compareBackground[(k % 7)]);

        // origsets
        origSetWeek.push(this.questCharts[quest.getId().toString()][i][1].data.datasets[k]);
        origSetHour.push(this.questCharts[quest.getId().toString()][i][2].data.datasets[k]);

        // Generate new sets
        setsWeekData.push({
          label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString(),
          data: stats.days[k],
          backgroundColor: compareBackground[(k % 7)],
          borderColor: compareBorders[(k % 7)]
        });

        setsHourData.push({
          label: this.compareUser.getFirstName() + ' ' + this.compareUser.getLastName() + ' - ' + a.toString(),
          data: stats.hours[k],
          backgroundColor: compareBackground[(k % 7)],
          borderColor: compareBorders[(k % 7)]
        });
      }

      countData = countData.concat(stats.values);
      countDataBg = countDataBg.concat(countDataBgAdd);

      if (this.legends[quest.getId().toString()][i] !== undefined) {
        this.legends[quest.getId().toString()][i] = legendTemp;
      }

      this.questCharts[quest.getId().toString()][i][0].data.labels = nLabel;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = countData;
      this.questCharts[quest.getId().toString()][i][0].data.datasets[0].backgroundColor = countDataBg;
      this.questCharts[quest.getId().toString()][i][0].update();

      this.questCharts[quest.getId().toString()][i][1].data.datasets = origSetWeek.concat(setsWeekData);
      this.questCharts[quest.getId().toString()][i][1].update();

      this.questCharts[quest.getId().toString()][i][2].data.datasets = origSetHour.concat(setsHourData);
      this.questCharts[quest.getId().toString()][i][2].update();
    }
  }

  /**
   * This function gets the actual study
   * @param studyId id of group
   */
  public getStudy(studyId: Study) {

    if (this.masterStudyId !== studyId.valueOf()) {
      this.groupService.getGroupDetail(this.masterStudyId.toString()).subscribe(dd => {
        if (dd instanceof BasicError) {
          console.log('Failed to get masterStudy');
        } else if (dd instanceof Study) {
          this.masterStudy = dd;

          this.groupService.getGroupDetail(studyId.toString()).subscribe(data => {
            if (data instanceof BasicError) {
              console.log('Error occured while reading study');
            } else if (data instanceof Study) {
              this.currentStudy = data;
            }
          });
        }
      });
    } else {
      this.groupService.getGroupDetail(studyId.toString()).subscribe(data => {
        if (data instanceof BasicError) {
          console.log('Error occured while reading study');
        } else if (data instanceof Study) {
          this.currentStudy = data;
          this.masterStudy = data;
        }
      });
    }
  }

  /**
   * This function processes the questionaires and prepares the data for the view
   */
  public processQuestionaires() {
    this.questionnairesOnce = 0;
    this.questionnairesMultiple = 0;
    this.questionnairesMultipleElementCount = 0; // Counter for loading the elements
    this.multipleQuestionaires = [];
    this.multipleQuestionnairesElements = {};
    this.questionnaireAnswersheets = {};
    this.answerSheetsLoaded = false;
    this.members = [];
    this.amountAnswersheets = 0;
    this.answersheets = {};
    this.allAnswersheets = [];
    this.loadWeekdayCanvas = false;
    this.loadHoursCanvas = false;
    this.barChart = null;
    this.lineChart = null;
    this.questCharts = {};
    this.chartDrawCounter = {};
    this.legends = {};

    for (let i = 0; i < this.questionnaires.length; i++) {
      const quest = this.questionnaires[i];

      if (quest instanceof Questionnaire) {
        if (quest.isOneTime()) {
          this.questionnairesOnce = this.questionnairesOnce + 1;
        }

        if (quest.isMultiple()) {
          this.questionnairesMultiple = this.questionnairesMultiple + 1;
          this.multipleQuestionaires.push(quest);
        }
      }
    }

    this.questionnairesIsLoaded = true;

    // Loading Answersheet of multiple questionnaires
    for (let i = 0; i < this.multipleQuestionaires.length; i++) {
      this.loadElementsOfQuestionnaire(this.multipleQuestionaires[i]);
    }

    this.loadAnswersheetsOfQuestionaire();
  }

  /**
   * Loading the elements of a specific questionnaire
   * @param quest loading elements of this questionnaire
   */
  public loadElementsOfQuestionnaire(quest: Questionnaire) {
    this.hcpQuest.getQuestionnaireElements(quest).subscribe(elements => {
      if (elements instanceof BasicError) {
        console.log('Failed to load Elements of questionnaire.');
        console.log(elements);
      } else if (elements instanceof Array) {
        this.multipleQuestionnairesElements[quest.getId().toString()] = {};
        this.multipleQuestionnairesElements[quest.getId().toString()]['quest'] = quest;
        this.multipleQuestionnairesElements[quest.getId().toString()]['elements'] = elements;
      }

      // increment counter
      this.questionnairesMultipleElementCount = this.questionnairesMultipleElementCount + 1;
    });
  }



  /**
   * Loading the Answersheets of an questionnaire
   */
  public loadAnswersheetsOfQuestionaire() {
    // Defining filters
    const limit = 0; // all answersheets
    const sort = null; // no sorting
    let filters = null; // filtering

    if (this.selectTime !== 'all') {
      if (this.getAnswersFrom !== null) {
        filters = 'collected_at>' + this.getAnswersFrom.toString();
      }

      if (this.getAnswersTo !== null && this.getAnswersFrom !== null) {
        filters += '&collected_at<' + this.getAnswersTo.toString();
      } else if (this.getAnswersTo !== null) {
        filters += 'collected_at<' + this.getAnswersTo.toString();
      }
    }

    // Getting Users
    this.hcpGroup.getMembersOfStudy(this.studyId).subscribe(members => {
      if (members instanceof BasicError) {
        console.log('Failed to load members of study.');
        console.log(members);
      } else if (members instanceof Array) {
        // A part of members were loaded
        this.members = members;
        this.answerSheetsLoaded = true;
      }
    });

    for (let j = 0; j < this.multipleQuestionaires.length; j++) {
      const qId = this.multipleQuestionaires[j].getId();
      this.hcpQuest.getAnswersheetsOfMemberAlternative(this.studyId, qId, null,
        limit, 0, sort, filters).subscribe(data => {
          if (data instanceof BasicError) {
            console.log('Error in loading Answersheet of member');
          } else if (data instanceof Array) {
            this.amountAnswersheets = this.amountAnswersheets + data.length;
            this.allAnswersheets = this.allAnswersheets.concat(data);
            if (data.length > 0) {
              if (this.answersheets[qId] === undefined) {
                this.answersheets[qId] = data;
              } else {
                this.answersheets[qId] =
                  this.answersheets[qId].concat(data);
              }

              this.calcWeekdays();
              this.calcHours();
            }
          }
        });
    }
  }

  /**
   * Creatieng Weekday chart
   */
  public calcWeekdays() {
    const weekdays = this.statistics.calcAverageWeekdays(this.allAnswersheets);
    let max = Math.max(...weekdays);

    if ((max * 0.1) > 2) {
      max = max + (Math.floor((max * 0.1)));
    } else {
      max = max + 2;
    }

    this.loadWeekdayCanvas = true;
    const data = {
      labels: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      datasets: [{
        data: weekdays,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
          'rgba(255,99,132,1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)'
        ],
      }]
    };

    const chartOptions = {
      scales: {
        yAxes: [{
          ticks: {
            max: max,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const ctrl = this;

    // Getting element
    setTimeout(function () {
      const canvas = $('#weekdayCanvas').get(0);

      if (ctrl.barChart === undefined || ctrl.barChart === null) {
        ctrl.barChart = new Chart(canvas, {
          type: 'bar',
          data: data,
          options: chartOptions
        });
      } else {
        ctrl.barChart.data.datasets[0].data = weekdays;
        ctrl.barChart.options.scales.yAxes[0].ticks.max = max;
        ctrl.barChart.update();
      }

    }, 100);
  }

  /**
   * Creating Hours Chart
   */
  public calcHours() {
    const hours = this.statistics.calcAverageHours(this.allAnswersheets);

    let max = Math.max(...hours);

    if ((max * 0.1) > 2) {
      max = max + (Math.floor((max * 0.1)));
    } else {
      max = max + 2;
    }

    const labels = [];
    for (let i = 0; i < 48; i++) {
      let time = '';
      if (i % 2 === 0) {
        time = (i / 2 <= 9) ? '0' + (i / 2) + ':00' : (i / 2) + ':00';
      } else {
        time = ((i - 1) / 2 <= 9) ? '0' + ((i - 1) / 2) + ':30' : ((i - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels.push(time);
    }

    const data = {
      labels: labels,
      datasets: [{
        data: hours,
        backgroundColor:
          'rgba(54, 162, 235, 0.2)'
        ,
        borderColor:
          'rgba(54, 162, 235, 1)'
      }]
    };

    const chartOptions = {
      scales: {
        yAxes: [{
          ticks: {
            max: max,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const ctrl = this;

    // Getting element
    setTimeout(function () {
      const canvas = $('#hoursCanvas').get(0);

      if (ctrl.lineChart === undefined || ctrl.lineChart === null) {
        ctrl.lineChart = new Chart(canvas, {
          type: 'line',
          data: data,
          options: chartOptions
        });
      } else {
        ctrl.lineChart.data.datasets[0].data = hours;
        ctrl.lineChart.options.scales.yAxes[0].ticks.max = max;
        ctrl.lineChart.update();
      }

    }, 100);
  }

  /**
   * This function draws a yesno pie chart
   * @param quest Questionnaire of questions
   * @param element Element to evaluate
   * @param i iteration param
   */
  public drawYesNoPieChart(quest: Questionnaire, element: QuestionnaireElementYesNo, i) {
    if (this.chartDrawCounter[quest.getId().toString()] === null || this.chartDrawCounter[quest.getId().toString()] === undefined) {
      this.chartDrawCounter[quest.getId().toString()] = {};
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] === undefined) {
      this.chartDrawCounter[quest.getId().toString()][i] = 0;
    }

    if (this.answersheets[quest.getId().toString()] === undefined || this.answersheets[quest.getId().toString()] === null) {
      this.answersheets[quest.getId().toString()] = [];
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] >= this.answersheets[quest.getId().toString()].length) {
      return;
    }

    this.chartDrawCounter[quest.getId().toString()][i] = this.answersheets[quest.getId().toString()].length;



    const pieId = '#elementCanvas' + i + '-' + quest.getId();
    const hourYesId = '#hoursElementYesCanvas' + i + '-' + quest.getId();
    const hourNoId = '#hoursElementNoCanvas' + i + '-' + quest.getId();
    const dayYesId = '#daysElementYesCanvas' + i + '-' + quest.getId();
    const dayNoId = '#daysElementNoCanvas' + i + '-' + quest.getId();

    const stats = this.statistics.calcYesNoAnswers(element, this.answersheets[quest.getId().toString()]);

    const max = [Math.max(...(stats.hoursYes.concat(stats.hoursNo))),
    Math.max(...stats.hoursNo), Math.max(...(stats.weekdayYes).concat(stats.weekdayNo)), Math.max(...stats.weekdayNo)];

    for (let k = 0; k < max.length; k++) {
      if ((max[k] * 0.1) > 2) {
        max[k] = max[k] + (Math.floor((max[k] * 0.1)));
      } else {
        max[k] = max[k] + 2;
      }
    }

    const labels = [];
    for (let k = 0; k < 48; k++) {
      let time = '';
      if (k % 2 === 0) {
        time = (k / 2 <= 9) ? '0' + (k / 2) + ':00' : (k / 2) + ':00';
      } else {
        time = ((k - 1) / 2 <= 9) ? '0' + ((k - 1) / 2) + ':30' : ((k - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels.push(time);
    }

    const labels2 = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    const labels3 = ['Ja', 'Nein'];

    const dataWeekYes = {
      labels: labels2,
      datasets: [{
        label: 'Ja',
        data: stats.weekdayYes,
        backgroundColor: 'rgba(75, 192, 192, 0.4)',
        borderColor: 'rgba(75, 192, 192, 1)',
      }, {
        label: 'Nein',
        data: stats.weekdayNo,
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255,99,132,1)',
      }]
    };

    const dataHoursYes = {
      labels: labels,
      datasets: [{
        label: 'Ja',
        data: stats.hoursYes,
        backgroundColor:
          'rgba(75, 192, 192, 0.4)',
        borderColor: 'rgba(75, 192, 192, 1)'
      }, {
        label: 'Nein',
        data: stats.hoursNo,
        backgroundColor:
          'rgba(255,99,132,0.4)',
        borderColor: 'rgba(255,99,132,1)'
      }]
    };

    const dataCount = {
      labels: labels3,
      datasets: [{
        data: stats.count,
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255,99,132,1)'
        ],
      }]
    };

    const chartOptionsHY = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[0],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const chartOptionsWY = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[2],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };


    const ctrl = this;

    // Getting element
    setTimeout(function () {
      const canvas = $(pieId).get(0);
      const canvasHY = $(hourYesId).get(0);
      const canvasWY = $(dayYesId).get(0);


      if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null ||
        ctrl.questCharts[quest.getId().toString()][i] === undefined || ctrl.questCharts[quest.getId().toString()][i] === null) {
        if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null) {
          ctrl.questCharts[quest.getId().toString()] = {};
        }


        ctrl.questCharts[quest.getId().toString()][i] = [null, null, null, null, null];

        ctrl.questCharts[quest.getId().toString()][i][0] = new Chart(canvas, {
          type: 'doughnut',
          data: dataCount,
          options: chartOptions
        });


        ctrl.questCharts[quest.getId().toString()][i][1] = new Chart(canvasWY, {
          type: 'bar',
          data: dataWeekYes,
          options: chartOptionsWY
        });

        ctrl.questCharts[quest.getId().toString()][i][3] = new Chart(canvasHY, {
          type: 'line',
          data: dataHoursYes,
          options: chartOptionsHY
        });
      } else {

        ctrl.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = stats.count;
        ctrl.questCharts[quest.getId().toString()][i][0].update();

        ctrl.questCharts[quest.getId().toString()][i][1].data.datasets[0].data = stats.weekdayYes;
        ctrl.questCharts[quest.getId().toString()][i][1].data.datasets[1].data = stats.weekdayNo;
        ctrl.questCharts[quest.getId().toString()][i][1].options.scales.yAxes[0].ticks.max = max[2];
        ctrl.questCharts[quest.getId().toString()][i][1].update();

        ctrl.questCharts[quest.getId().toString()][i][3].data.datasets[0].data = stats.hoursYes;
        ctrl.questCharts[quest.getId().toString()][i][3].data.datasets[1].data = stats.hoursNo;
        ctrl.questCharts[quest.getId().toString()][i][3].options.scales.yAxes[0].ticks.max = max[0];
        ctrl.questCharts[quest.getId().toString()][i][3].update();
      }

    }, 100);

  }

  /**
   * Draws single choice questionnaire elements
   * @param quest Questionnaire
   * @param element Element of Questionnaire
   * @param i iteration param
   */
  public drawSingleChoiceChart(quest: Questionnaire, element: QuestionnaireElementSingleChoice, i) {
    if (this.chartDrawCounter[quest.getId().toString()] === null || this.chartDrawCounter[quest.getId().toString()] === undefined) {
      this.chartDrawCounter[quest.getId().toString()] = {};
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] === undefined) {
      this.chartDrawCounter[quest.getId().toString()][i] = 0;
    }

    if (this.answersheets[quest.getId().toString()] === undefined || this.answersheets[quest.getId().toString()] === null) {
      this.answersheets[quest.getId().toString()] = [];
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] >= this.answersheets[quest.getId().toString()].length) {
      return;
    }

    this.chartDrawCounter[quest.getId().toString()][i] = this.answersheets[quest.getId().toString()].length;


    const backgrounds = ['rgba(255,99,132,1)',
      'rgba(54, 162, 235, 0.4)',
      'rgba(255, 206, 86, 0.4)',
      'rgba(75, 192, 192, 0.4)',
      'rgba(153, 102, 255, 0.4)',
      'rgba(255, 159, 64, 0.4)',
      'rgba(255, 102, 255, 0.4)'
    ];

    const borders = ['rgba(255,99,132,0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(255, 102, 255, 0.2)'
    ];

    const pieId = '#elementCanvas' + i + '-' + quest.getId();
    const weekId = '#daysElementYesCanvas' + i + '-' + quest.getId();
    const hourId = '#hoursElementYesCanvas' + i + '-' + quest.getId();



    const stats = this.statistics.calcSingleChoiceAnswers(element, this.answersheets[quest.getId().toString()]);


    // Create Legends
    if (this.legends[quest.getId().toString()] === undefined) {
      this.legends[quest.getId().toString()] = {};
    }

    if (this.legends[quest.getId().toString()][i] === undefined) {
      const legend = [];

      for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        const a = element.getAnswers(this.translate.getSingleElementLanguage())[j];
        const l = {
          'color': backgrounds[(j % 7)],
          'value': a
        };
        legend.push(l);
      }

      this.legends[quest.getId().toString()][i] = legend;
    }

    const labels = [];
    const bgs = [];
    const weekData = [];
    const hoursData = [];
    const max = [2, 2];

    for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
      const a = element.getAnswers(this.translate.getSingleElementLanguage())[j];
      labels.push(a);
      bgs.push(backgrounds[(j % 7)]);

      const w = {
        label: a.toString(),
        data: stats.weekday[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      };

      const h = {
        label: a.toString(),
        data: stats.hours[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      }

      max[0] = Math.max(...(stats.weekday[j].concat([max[0]]))) + 2;
      max[1] = Math.max(...(stats.hours[j].concat([max[1]]))) + 2;

      weekData.push(w);
      hoursData.push(h);
    }

    // Pie Chart Data

    const dataCount = {
      labels: labels,
      datasets: [{
        data: stats.count,
        backgroundColor: bgs,
      }]
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };


    // Weekday chart
    const labels2 = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    const dataWeek = {
      labels: labels2,
      datasets: weekData
    };

    const chartOptionWeek = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[0],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Hours Chart
    const labels3 = [];
    for (let k = 0; k < 48; k++) {
      let time = '';
      if (k % 2 === 0) {
        time = (k / 2 <= 9) ? '0' + (k / 2) + ':00' : (k / 2) + ':00';
      } else {
        time = ((k - 1) / 2 <= 9) ? '0' + ((k - 1) / 2) + ':30' : ((k - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels3.push(time);
    }

    const dataHours = {
      labels: labels3,
      datasets: hoursData
    };

    const chartOptionHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[1],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };



    const ctrl = this;

    setTimeout(function () {
      const canvas = $(pieId).get(0);
      const dayC = $(weekId).get(0);
      const hourC = $(hourId).get(0);


      if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null ||
        ctrl.questCharts[quest.getId().toString()][i] === undefined || ctrl.questCharts[quest.getId().toString()][i] === null) {
        if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null) {
          ctrl.questCharts[quest.getId().toString()] = {};
        }


        ctrl.questCharts[quest.getId().toString()][i] = [null, null, null];

        ctrl.questCharts[quest.getId().toString()][i][0] = new Chart(canvas, {
          type: 'doughnut',
          data: dataCount,
          options: chartOptions
        });

        ctrl.questCharts[quest.getId().toString()][i][1] = new Chart(dayC, {
          type: 'bar',
          data: dataWeek,
          options: chartOptionWeek
        });

        ctrl.questCharts[quest.getId().toString()][i][2] = new Chart(hourC, {
          type: 'line',
          data: dataHours,
          options: chartOptionHour
        });
      } else {
        ctrl.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = stats.count;
        ctrl.questCharts[quest.getId().toString()][i][0].update();

        ctrl.questCharts[quest.getId().toString()][i][1].data.datasets = weekData;
        ctrl.questCharts[quest.getId().toString()][i][1].options.scales.yAxes[0].ticks.max = max[0];
        ctrl.questCharts[quest.getId().toString()][i][1].update();

        ctrl.questCharts[quest.getId().toString()][i][2].data.datasets = hoursData;
        ctrl.questCharts[quest.getId().toString()][i][2].options.scales.yAxes[0].ticks.max = max[1];
        ctrl.questCharts[quest.getId().toString()][i][2].update();
      }

    }, 300);
  }

  /**
   * This function draws the charts for slider elements
   * @param quest Questionnaire
   * @param element Questionnaire Element
   * @param i iteration indicator
   */
  public drawSliderChart(quest: Questionnaire, element: QuestionnaireElementSlider, i) {
    if (this.chartDrawCounter[quest.getId().toString()] === null || this.chartDrawCounter[quest.getId().toString()] === undefined) {
      this.chartDrawCounter[quest.getId().toString()] = {};
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] === undefined) {
      this.chartDrawCounter[quest.getId().toString()][i] = 0;
    }

    if (this.answersheets[quest.getId().toString()] === undefined || this.answersheets[quest.getId().toString()] === null) {
      this.answersheets[quest.getId().toString()] = [];
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] >= this.answersheets[quest.getId().toString()].length) {
      return;
    }

    this.chartDrawCounter[quest.getId().toString()][i] = this.answersheets[quest.getId().toString()].length;

    const stats = this.statistics.calcSliderAnswers(element, this.answersheets[quest.getId().toString()]);

    const overviewId = '#daysElementYesCanvas' + i + '-' + quest.getId();
    const hourId = '#hoursElementYesCanvas' + i + '-' + quest.getId();

    const backgrounds = ['rgba(255,99,132,0.4)',
      'rgba(54, 162, 235, 0.4)',
      'rgba(255, 206, 86, 0.4)',
      'rgba(75, 192, 192, 0.4)',
      'rgba(153, 102, 255, 0.4)',
      'rgba(255, 159, 64, 0.4)',
      'rgba(255, 102, 255, 0.4)'
    ];

    const borders = ['rgba(255,99,132,0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(255, 102, 255, 0.2)'
    ];

    const random = (i % 7);

    const bg = backgrounds[random];
    const bb = borders[random];


    // Create Legends
    if (this.legends[quest.getId().toString()] === undefined) {
      this.legends[quest.getId().toString()] = {};
    }

    if (this.legends[quest.getId().toString()][i] === undefined) {
      const legend = [];

      for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        const a = element.getAnswers(this.translate.getSingleElementLanguage())[j];
        const l = {
          'value': a.value,
          'label': a.label,
          'icon': a.icon
        };
        legend.push(l);
      }

      this.legends[quest.getId().toString()][i] = legend;
    }

    // Ranges
    const labels = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    const max = Math.max(...stats.ranges) + 2;

    const dataRanges = {
      labels: labels,
      datasets: [{
        data: stats.ranges,
        backgroundColor: bb,
        borderColor: bg
      }]
    };

    const rangeOptions = {
      scales: {
        yAxes: [{
          ticks: {
            max: max,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Hours
    const labels3 = [];
    for (let k = 0; k < 24; k++) {
      let time = '';
      time = (k < 10) ? '0' + k : k + '';
      time = time + ' Uhr';
      labels3.push(time);
    }

    const dataHours = {
      labels: labels3,
      datasets: [{
        data: stats.hours,
        backgroundColor: bb,
        borderColor: bg
      }]
    };

    const chartOptionHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: 100,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const ctrl = this;

    setTimeout(function () {
      const canvas = $(overviewId).get(0);
      const hourC = $(hourId).get(0);


      if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null ||
        ctrl.questCharts[quest.getId().toString()][i] === undefined || ctrl.questCharts[quest.getId().toString()][i] === null) {
        if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null) {
          ctrl.questCharts[quest.getId().toString()] = {};
        }


        ctrl.questCharts[quest.getId().toString()][i] = [null, null, null];

        ctrl.questCharts[quest.getId().toString()][i][0] = new Chart(canvas, {
          type: 'bar',
          data: dataRanges,
          options: rangeOptions
        });

        ctrl.questCharts[quest.getId().toString()][i][1] = new Chart(hourC, {
          type: 'line',
          data: dataHours,
          options: chartOptionHour
        });
      } else {
        ctrl.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = stats.ranges;
        ctrl.questCharts[quest.getId().toString()][i][0].options.scales.yAxes[0].ticks.max = max;
        ctrl.questCharts[quest.getId().toString()][i][0].update();

        ctrl.questCharts[quest.getId().toString()][i][1].data.datasets[0].data = stats.hours;
        ctrl.questCharts[quest.getId().toString()][i][1].update();
      }

    }, 400);

  }

  /**
   * This function draws the charts for multiplechoice element
   * @param quest Questionnaire
   * @param element Questionnaire element
   * @param i iteration indicator
   */
  public drawMultipleChoiceChart(quest: Questionnaire, element: QuestionnaireElementMultipleChoice, i) {
    if (this.chartDrawCounter[quest.getId().toString()] === null || this.chartDrawCounter[quest.getId().toString()] === undefined) {
      this.chartDrawCounter[quest.getId().toString()] = {};
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] === undefined) {
      this.chartDrawCounter[quest.getId().toString()][i] = 0;
    }

    if (this.answersheets[quest.getId().toString()] === undefined || this.answersheets[quest.getId().toString()] === null) {
      this.answersheets[quest.getId().toString()] = [];
    }

    if (this.chartDrawCounter[quest.getId().toString()][i] >= this.answersheets[quest.getId().toString()].length) {
      return;
    }

    this.chartDrawCounter[quest.getId().toString()][i] = this.answersheets[quest.getId().toString()].length;

    const backgrounds = ['rgba(255,99,132,0.4)',
      'rgba(54, 162, 235, 0.4)',
      'rgba(255, 206, 86, 0.4)',
      'rgba(75, 192, 192, 0.4)',
      'rgba(153, 102, 255, 0.4)',
      'rgba(255, 159, 64, 0.4)',
      'rgba(255, 102, 255, 0.4)'
    ];

    const borders = ['rgba(255,99,132,0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(255, 102, 255, 0.2)'
    ];

    const stats = this.statistics.calcMultipleAnswers(element, this.answersheets[quest.getId().toString()]);
    const pieId = '#elementCanvas' + i + '-' + quest.getId();
    const weekId = '#daysElementYesCanvas' + i + '-' + quest.getId();
    const hourId = '#hoursElementYesCanvas' + i + '-' + quest.getId();

    // Create Legends
    if (this.legends[quest.getId().toString()] === undefined) {
      this.legends[quest.getId().toString()] = {};
    }

    if (this.legends[quest.getId().toString()][i] === undefined) {
      const legend = [];

      for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        const a = element.getAnswers(this.translate.getSingleElementLanguage())[j];
        const l = {
          'color': backgrounds[(j % 7)],
          'value': a
        };
        legend.push(l);
      }

      this.legends[quest.getId().toString()][i] = legend;
    }

    const labels = [];
    const bgs = [];
    const brds = [];
    const weekData = [];
    const hoursData = [];
    const max = [2, 2];

    for (let j = 0; j < element.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
      const a = element.getAnswers(this.translate.getSingleElementLanguage())[j];
      labels.push(a);
      bgs.push(backgrounds[(j % 7)]);
      brds.push(backgrounds[(j % 7)]);

      const w = {
        label: a.toString(),
        data: stats.days[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      };

      const h = {
        label: a.toString(),
        data: stats.hours[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      }

      max[0] = Math.max(...(stats.days[j].concat([max[0]]))) + 2;
      max[1] = Math.max(...(stats.hours[j].concat([max[1]]))) + 2;

      weekData.push(w);
      hoursData.push(h);
    }

    // Pie Chart Data
    const dataCount = {
      labels: labels,
      datasets: [{
        data: stats.values,
        backgroundColor: bgs,
        borderColor: brds
      }]
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Weekday chart
    const labels2 = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    const dataWeek = {
      labels: labels2,
      datasets: weekData
    };

    const chartOptionWeek = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[0],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Hours Chart
    const labels3 = [];
    for (let k = 0; k < 48; k++) {
      let time = '';
      if (k % 2 === 0) {
        time = (k / 2 <= 9) ? '0' + (k / 2) + ':00' : (k / 2) + ':00';
      } else {
        time = ((k - 1) / 2 <= 9) ? '0' + ((k - 1) / 2) + ':30' : ((k - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels3.push(time);
    }

    const dataHours = {
      labels: labels3,
      datasets: hoursData
    };

    const chartOptionHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[1],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };



    const ctrl = this;

    setTimeout(function () {
      const canvas = $(pieId).get(0);
      const dayC = $(weekId).get(0);
      const hourC = $(hourId).get(0);


      if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null ||
        ctrl.questCharts[quest.getId().toString()][i] === undefined || ctrl.questCharts[quest.getId().toString()][i] === null) {
        if (ctrl.questCharts[quest.getId().toString()] === undefined || ctrl.questCharts[quest.getId().toString()] === null) {
          ctrl.questCharts[quest.getId().toString()] = {};
        }


        ctrl.questCharts[quest.getId().toString()][i] = [null, null, null];

        ctrl.questCharts[quest.getId().toString()][i][0] = new Chart(canvas, {
          type: 'doughnut',
          data: dataCount,
          options: chartOptions
        });

        ctrl.questCharts[quest.getId().toString()][i][1] = new Chart(dayC, {
          type: 'bar',
          data: dataWeek,
          options: chartOptionWeek
        });

        ctrl.questCharts[quest.getId().toString()][i][2] = new Chart(hourC, {
          type: 'line',
          data: dataHours,
          options: chartOptionHour
        });
      } else {
        ctrl.questCharts[quest.getId().toString()][i][0].data.datasets[0].data = stats.values;
        ctrl.questCharts[quest.getId().toString()][i][0].update();

        ctrl.questCharts[quest.getId().toString()][i][1].data.datasets = weekData;
        ctrl.questCharts[quest.getId().toString()][i][1].options.scales.yAxes[0].ticks.max = max[0];
        ctrl.questCharts[quest.getId().toString()][i][1].update();

        ctrl.questCharts[quest.getId().toString()][i][2].data.datasets = hoursData;
        ctrl.questCharts[quest.getId().toString()][i][2].options.scales.yAxes[0].ticks.max = max[1];
        ctrl.questCharts[quest.getId().toString()][i][2].update();
      }

    }, 300);
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-statistics/group-details-statistics.component.ts